var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapellaLogoRgb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 219.85 52.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#01243c;}.cls-3{fill:#fff;}.cls-4{fill:#40afd4;}.cls-5{fill:url(#linear-gradient-8);}.cls-6{fill:url(#linear-gradient-9);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-14);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-12);}.cls-16{fill:url(#linear-gradient-10);}.cls-17{fill:url(#linear-gradient-11);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 25.56,
    y1: 2.99,
    x2: 47.46,
    y2: 13.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40afd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0074ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32.56,
    y1: 33.51,
    x2: 22.07,
    y2: 33.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 39.1,
    y1: 49.4,
    x2: 15.42,
    y2: 49.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -156.15,
    y1: 776.68,
    x2: -166.64,
    y2: 776.56,
    gradientTransform: "translate(-474.92 -579.22) rotate(-51.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -149.62,
    y1: 792.57,
    x2: -173.3,
    y2: 792.57,
    gradientTransform: "translate(-474.92 -579.22) rotate(-51.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3.32,
    y1: 34.66,
    x2: 8.68,
    y2: 11.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 36.74,
    y1: 12.88,
    x2: 41.74,
    y2: 35.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 43.26,
    y1: 33.15,
    x2: 39.63,
    y2: 15.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 24.68,
    y1: 20.42,
    x2: 34.3,
    y2: 24.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -163.15,
    y1: 746.16,
    x2: -141.26,
    y2: 756.89,
    gradientTransform: "translate(-474.92 -579.22) rotate(-51.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -164.03,
    y1: 763.59,
    x2: -154.41,
    y2: 768.15,
    gradientTransform: "translate(-474.92 -579.22) rotate(-51.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 20.42,
    y1: 31.85,
    x2: 22.89,
    y2: 21.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -185.39,
    y1: 777.83,
    x2: -180.03,
    y2: 754.89,
    gradientTransform: "translate(-474.92 -579.22) rotate(-51.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -168.29,
    y1: 775.02,
    x2: -165.82,
    y2: 764.28,
    gradientTransform: "translate(-474.92 -579.22) rotate(-51.43)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m79.96,36.36c-1.96-1.89-2.94-5.19-2.94-9.89,0-3.03.4-5.48,1.2-7.33.8-1.86,2.02-3.21,3.65-4.05s3.74-1.27,6.33-1.27c1.18,0,2.22.08,3.14.25.92.17,1.65.36,2.19.6v4.55c-.47-.21-1.12-.4-1.94-.56-.82-.16-1.75-.25-2.79-.25-1.55,0-2.78.25-3.68.74-.91.49-1.57,1.32-1.99,2.47s-.63,2.75-.63,4.79c0,2.19.26,3.88.78,5.08.52,1.2,1.23,2.02,2.13,2.47.9.45,2.04.67,3.4.67.99,0,1.96-.11,2.91-.33.95-.22,1.65-.46,2.1-.72v4.69c-.52.24-1.32.45-2.42.65s-2.23.3-3.4.3c-3.38,0-6.06-.95-8.02-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m111.11,32.96h-7.97l-1.02,5.89h-5.47l4.8-24.68h11.42l4.79,24.68h-5.54l-1.02-5.89Zm-.78-4.34l-1.8-10.16h-2.82l-1.8,10.16h6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m135.02,14.89c1.39.48,2.46,1.33,3.21,2.54.75,1.21,1.13,2.87,1.13,4.99s-.38,3.81-1.13,5.02c-.75,1.21-1.82,2.05-3.21,2.52-1.39.47-3.12.71-5.18.71h-3.14v8.18h-5.29V14.17h8.43c2.07,0,3.8.24,5.18.72Zm-2.04,10.58c.61-.6.92-1.62.92-3.05s-.31-2.45-.92-3.05-1.71-.9-3.28-.9h-3v7.9h3c1.57,0,2.67-.3,3.28-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m159.1,34.55v4.3h-16.08V14.17h15.83v4.3h-10.54v5.71h8.32v4.44h-8.32v5.92h10.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m178.63,34.55v4.3h-15.27V14.17h5.29v20.38h9.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m197.11,34.55v4.3h-15.27V14.17h5.29v20.38h9.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m213.3,32.96h-7.97l-1.02,5.89h-5.47l4.8-24.68h11.42l4.79,24.68h-5.54l-1.02-5.89Zm-.78-4.34l-1.8-10.16h-2.82l-1.8,10.16h6.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.22 33.57 37.84 50.35 16.37 50.35 2.98 33.57 7.75 12.62 27.11 3.27 46.47 12.62 51.22 33.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "39.24 30.58 32.51 39.01 21.71 39.01 14.98 30.58 17.38 20.04 27.11 15.34 36.85 20.04 39.24 30.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m48.85,10.47L27.11,0,5.37,10.47,0,34l15.04,18.86h24.13l15.05-18.86-5.37-23.53Zm-13.01,35.47h-17.47l-10.89-13.66,3.89-17.03,15.74-7.58,15.74,7.58,3.88,17.03-10.89,13.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.85 10.47 42.85 15.26 27.11 7.68 27.11 0 48.85 10.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "32.51 39.01 21.71 39.01 27.11 27.81 32.51 39.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "39.17 52.85 15.05 52.85 18.38 45.94 35.84 45.94 39.17 52.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "39.24 30.57 32.51 39.02 27.11 27.81 39.24 30.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "54.21 33.99 39.17 52.86 35.85 45.95 46.74 32.29 54.21 33.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "5.37 10.47 11.38 15.26 7.49 32.29 0 34 5.37 10.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "27.11 27.81 54.22 34 48.85 10.47 27.11 27.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "36.85 20.04 39.24 30.58 46.73 32.29 42.85 15.26 36.85 20.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "27.11 27.81 36.85 20.04 27.11 15.34 27.11 27.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "27.11 0 27.12 7.68 11.38 15.26 5.37 10.47 27.11 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "27.11 27.81 27.11 15.35 17.37 20.03 27.11 27.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "17.38 20.04 27.11 27.81 14.98 30.58 17.38 20.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "0 34 7.49 32.29 18.38 45.94 15.05 52.86 0 34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "14.97 30.58 27.11 27.81 21.71 39.02 14.97 30.58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapellaLogoRgb);
export default __webpack_public_path__ + "static/media/capella_logo_rgb.2d4c28f5eb807e761722e67021f441d2.svg";
export { ForwardRef as ReactComponent };